module.exports = __webpack_public_path__ + "static/media/dodgem(26).c3e38947.PNG";